import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { fetchFacturesProjet } from '../../api/factureAchatApi';

const FacturationParProjet = ({ projetId }) => {
  const [factures, setFactures] = useState([]);

useEffect(() => {
  const loadFactures = async () => {
    if (!projetId) {
      console.warn("projetId est undefined, impossible de charger les factures.");
      return;
    }
    try {
      const data = await fetchFacturesProjet(projetId);
      setFactures(data);
    } catch (error) {
      console.error("Erreur lors du chargement des factures :", error);
    }
  };
  loadFactures();
}, [projetId]);


  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'numero', headerName: 'Numéro', width: 150 },
    { field: 'montant', headerName: 'Montant', width: 150 },
    { field: 'date', headerName: 'Date', width: 150 },
  ];

  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={factures}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5]}
      />
    </div>
  );
};

export default FacturationParProjet;
